import { useMemo } from "react";
import { useParams } from "react-router";

import { TagAnalyticsSection } from "@/components/tag/tag-analytics-section";
import { TagDetailsSection } from "@/components/tag/tag-details-section";
import { TagProductSection } from "@/components/tag/tag-product-section";
import { Header } from "@/components/ui/header";
import { useGetSKUForTagQuery, useGetTagQuery } from "@/data/queries";
import { canViewAnalytics } from "@/lib/permissions";
import useStore from "@/state";

export const Tag = () => {
  const { tagUid } = useParams<{ tagUid: string }>();
  const {
    data: tag,
    isLoading: tagIsLoading,
    isSuccess,
  } = useGetTagQuery(tagUid!);
  const { data: sku, isLoading: skuIsLoading } = useGetSKUForTagQuery(
    tagUid,
    tag?.template_id,
    isSuccess,
  );
  const { session } = useStore();

  const hasPermission = useMemo(
    () => canViewAnalytics(session?.permissions),
    [session?.permissions],
  );

  if (tagIsLoading || skuIsLoading) {
    return <div />;
  }

  if (!tag) {
    // TODO: Create empty states: https://linear.app/legitimatetech/issue/ENG-932/empty-state
    return <div>No data</div>;
  }

  return (
    <div className="w-full">
      <Header
        title={`Tag ${tagUid}`}
        description={`SKU ${sku?.id} - ${sku?.name}`}
        size="xl"
        separator
      />
      <div className="flex flex-col gap-6">
        <div className="flex gap-4 mt-4 items-stretch">
          <TagProductSection sku={sku} />
          <TagDetailsSection sku={sku} tag={tag} />
        </div>
        <TagAnalyticsSection tag={tag} allowed={hasPermission} />
      </div>
    </div>
  );
};
